export const getCurrencySymbol = intl =>
  intl
    .formatNumberToParts(0, {
      format: 'currency',
    })
    ?.find(({ type }) => type === 'currency')?.value;

export const formatCurrency = (intl, value) =>
  intl.formatNumber(value, {
    format: 'currency',
  });
